import SelectCourseRefereeModalController from 'cms/controller/contest/SelectCourseRefereeModalController';
import React from 'react'
import ReactModal from 'react-modal';
export default function SelectCourseRefereeModal({course,...props}) {


    const {modalIsOpen,
        courseReferees,
        closeModal,
        isLoading,
        pages,
        page,
        loadPage,
        setSelectedItem,
        userAvatar,} = SelectCourseRefereeModalController(course, props);

    return (
        <ReactModal
            closeTimeoutMS={500}
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="Modal"
            ariaHideApp={false}
            overlayClassName="Overlay"
        >
            <div className="modal-content">
                
                <div className="modal-body gallery padding-0 ">
                    <button type="button" className="close gallery-close" onClick={closeModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    
                    <div className="nav-tabs-custom  ">
                        <ul className="nav nav-tabs border-bottom-blue">
                            <li className="active"><a href={`#images`} data-toggle="tab">Select Referee</a></li>
                        </ul>
                        <div className="tab-content ">
                            <div className="tab-pane active" id="images">
                                {isLoading && (<>
                                    <div className="gallery-loading">
                                        Please Wait...
                                    </div>

                                </>)}
                                <div className="modal-tab nice-scroll">
                                    {courseReferees?.map(courseReferee => (
                                        <div key={courseReferee.id} className={`mb-10 mr-10 pull-left width-100`}>
                                            <a href="#noth" onClick={(e)=>{ e.preventDefault(); setSelectedItem(courseReferee) }} title={`${courseReferee.user?.profile?.first_name} ${courseReferee.user?.profile?.last_name}`} >
                                                <img src={userAvatar(courseReferee.user.profile)} className=" img-circle  margin-r-10 full-width" alt="" />
                                            </a>
                                            <div className="clear"></div>
                                        </div>
                                    ))}
                                    <div className="clear"></div>
                                </div>
                                
                                <ul className="pagination cms-pagination dark m-0 float-right">
                                    {pages && pages.map((page_number) => (
                                        <li key={page_number} className="page-item">
                                            <a className={page_number === page ? "page-link active" : "page-link"}
                                                href="#loadpage" onClick={(e) => { loadPage(e, page_number) }}>{page_number}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                        </div>
                    </div>


                </div>

            </div>
        </ReactModal>

    )
}
